var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "134px",
    height: "134px",
    viewBox: "0 0 134 134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wrapped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page02-Copy-6",
    transform: "translate(-120.000000, -109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(187.000000, 176.000000) rotate(-19.000000) translate(-187.000000, -176.000000) translate(120.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D60A52",
    cx: 67,
    cy: 67,
    r: 67
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(31.000000, 39.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3538903,0 C66.5764039,0 72.432247,5.8583619 72.432247,13.0851429 L72.432247,42.2749524 C72.432247,49.5018952 66.5770506,55.3600952 59.3538903,55.3600952 L55.8595272,55.3594476 L55.8601739,63.9739143 C55.8601739,66.1975143 54.0582641,68 51.8358278,68 C50.8461921,68 49.8913174,67.6350667 49.1535772,66.9754667 L36.1693175,55.3594476 L13.0783567,55.3600952 C5.85584308,55.3600952 0,49.5017333 0,42.2749524 L0,13.0851429 C0,5.8582 5.85519636,0 13.0783567,0 L59.3538903,0 Z",
    id: "Fill-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageRed);
export default __webpack_public_path__ + "static/media/messageRed.d87ed8d19762ce83e90a58601d22253e.svg";
export { ForwardRef as ReactComponent };